import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Navbar from '../../components/Navbar/Navbar';
import './Contactus.scss';
import ContactForm from '../../components/ContactForm/ContactForm';
import Footer from '../../sections/Footer/Footer';
import SEO from '../../components/SEO';
import { useTranslation } from '../../i18n/useTranslation';

const Contactus = ({ lang = 'en' }) => {
  const { t } = useTranslation();
  const BASE_URL = "https://alsaketdental.com";
  const SITE_NAME = "AlSaket Dental Clinics";
  const SITE_NAME_AR = "عيادات الساكت لطب الأسنان";

  const isArabic = lang === 'ar';
  const pageUrl = `${BASE_URL}/${lang}/contact`;

  // JSON-LD: Contact Page
  const contactPageLD = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact AlSaket Dental Clinics",
    "alternateName": "تواصل مع عيادات الساكت لطب الأسنان",
    "url": pageUrl,
    "description": "Contact us for any inquiries or appointment booking. Reach out via our contact form or available contact information.",
    "description_ar": "تواصل معنا لأي استفسار أو حجز موعد. اتصل بنا عبر نموذج الاتصال أو معلومات الاتصال المتوفرة.",
    "mainEntity": {
      "@type": "Dentist",
      "name": "AlSaket Dental Clinics",
      "alternateName": "عيادات الساكت لطب الأسنان",
      "url": "https://alsaketdental.com",
      "logo": "https://alsaketdental.com/images/logo.png",
      "sameAs": [
        "https://www.facebook.com/alsaketdental",
        "https://www.instagram.com/alsaketdental"
      ],
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Amman, Jordan",
        "addressLocality": "Amman",
        "addressRegion": "Amman",
        "addressCountry": "JO",
        "postalCode": "11183"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "31.9539",
        "longitude": "35.9106"
      },
      "telephone": "+962-79-2602666",
      "email": "info@alsaketdental.com",
      "openingHours": "Mo-Fr 09:00-18:00, Sa 09:00-14:00"
    }
  };

  // JSON-LD: ContactPoint
  const contactPointLD = {
    "@context": "https://schema.org",
    "@type": "ContactPoint",
    "contactType": "customer service",
    "email": "info@alsaketdental.com",
    "telephone": "+962-79-2602666",
    "areaServed": "JO",
    "availableLanguage": ["Arabic", "English"],
    "contactOption": ["TollFree", "HearingImpairedSupported"]
  };

  return (
    <>
      {/* SEO للصفحة - Bilingual */}
      <SEO
        title="Contact Us - AlSaket Dental Clinics"
        titleAr="تواصل معنا - عيادات الساكت"
        description="Contact us for any inquiries or appointment booking. Reach out via our contact form or available contact information. Professional dental care in Amman, Jordan."
        descriptionAr="تواصل معنا لأي استفسار أو حجز موعد. اتصل بنا عبر نموذج الاتصال أو معلومات الاتصال المتوفرة. رعاية أسنان مهنية في عمان، الأردن."
        keywords={[
          "contact dental clinic amman",
          "dental clinic contact jordan", 
          "book dental appointment amman",
          "dental consultation amman",
          "dental clinic phone amman",
          "dental clinic email amman",
          "dental clinic address amman",
          "dental clinic hours amman"
        ]}
        keywordsAr={[
          "تواصل عيادة أسنان عمان",
          "اتصال عيادة أسنان الأردن",
          "حجز موعد طبيب أسنان عمان",
          "استشارة طب الأسنان عمان",
          "هاتف عيادة أسنان عمان",
          "بريد عيادة أسنان عمان",
          "عنوان عيادة أسنان عمان",
          "ساعات عمل عيادة أسنان عمان"
        ]}
        url={pageUrl}
        image="https://alsaketdental.com/images/contact-og-image.jpg"
        siteName={SITE_NAME}
        siteNameAr={SITE_NAME_AR}
        structuredData={[contactPageLD, contactPointLD]}
        lang={isArabic ? 'ar' : 'en'}
      />

      {/* محتوى الصفحة */}
      <section className='section-bg section-common contact-section'>
        <Navbar />
        <SectionTitle 
          title={t('contact.title')}
          description={t('contact.description')}
        />
      </section>
      <section className='contact-form-area' data-aos="fade-up" data-aos-duration="2000">
        <ContactForm />
      </section>
      <Footer />
    </>
  );
};

export default Contactus;
